// Centralized constants for activities-tradein
export const SERVICE_BFF = 'bff';
